import React, { Component } from "react";
import axios from "axios";
import { Grid, Row, Col, Button, Image, Tooltip, OverlayTrigger } from "react-bootstrap";
import Header from "./Header.jsx";
import Banner from "./Banner.jsx";
import BackButton from "./BackButton.jsx";
import MemberCard from "./MemberCard.jsx";
import MemberContactModal from "./MemberContactModal.jsx";
import hyperlinks from "../../../src/util/hyperlinks";
import months from "../../../src/util/months";



export default class EventSponsors extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false
    };
    this.contactButtonClick = this.contactButtonClick.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  contactButtonClick(e) {
    if (this.props.currentUser) {
      const member = this.props.eventSponsors.find(member => member.id == e.target.parentElement.querySelector(".member").dataset.cardId);
      axios.post("/analytics_messages.json", { type: 'contact-card-click', member_id: member.id, current_user_id: this.props.currentUser.id });
      location.href = `mailto:${member.email}`;
    } else {
      axios.post("/analytics_messages.json", { type: 'contact-card-click', member_id: member.id, current_user_id: null });
      this.setState({ showModal: true });
    }
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  // render() {
  //   const eventSponsors = this.props.eventSponsors.map((member, i) => {
  //     let tab;
  //     if (member.short_name == "ch2m") {
  //       tab = <div className="tab">Inaugural Meeting Partner</div>;
  //     }

  //     return <MemberCard
  //       member={member}
  //       showNames={true}
  //       contactButtonClick={this.contactButtonClick}
  //       cardId={member.id}
  //       tab={tab}
  //       expanded={true}
  //       key={`member${i + 1}`}
  //     />;
  //   });
  //   return (
  //     <Header showCorporateMembers={this.props.showCorporateMembers} flashes={this.props.flashes} currentUser={this.props.currentUser}>
  //       <Grid className="with-background event-sponsors-page">
  //         <Banner heading="Event Sponsors" />
  //         <Row>
  //           <Col md={3}>
  //             <BackButton className="back-to-home" href={hyperlinks["events"]} text="❮ Events" />
  //           </Col>
  //           <Col md={3} mdOffset={6} className="text-right">
  //             <Button className="become-a-sponsor" href="mailto:a.smith@leadingutilities.org?Subject=Leading Utilities of the World - Event sponsorship&body=Dear Miss Abigail Smith,">{"Become a sponsor"}</Button>
  //           </Col>
  //         </Row>
  //         <Row className="event-sponsors-content">
  //           <Col md={12}>
  //             {eventSponsors}
  //           </Col>
  //         </Row>
  //         <MemberContactModal showModal={this.state.showModal} closeModal={this.closeModal} />
  //       </Grid>
  //     </Header>
  //   );
  // }
  render () {
    const description = "CH2M is a global engineering company which, as a part of its business, delivers projects across the entire water cycle to solve clients' most complex water challenges with exceptional service and integrated, sustainable solutions. As the Foundation Partner, CH2M is sponsoring all Leading Utilities of the World strands at the Global Water Summit, American Water Summit, Amsterdam International Water Week and Singapore International Water Week. In addition, CH2M sponsored the inaugural meeting of the Leading Utilities of the World at the Global Water Summit 2017 in Madrid. At this event CH2M representatives received the presentations of the six new utility members as audience members and gave utilities feedback at the roundtables following the presentations. With CH2M's support the Leading Utilities of the World network can continue to inaugurate new members in events around the world, contributing to a celebration of utility innovation and global partnerships aiming to raise the performance of the water sector worldwide.";
    const member = this.props.eventSponsors[0];
    const memberSince = new Date(member.member_since);
    let className = "member expanded";
    let basicContent = (
      <div className={className} onClick={this.props.handleClick} data-card-id={this.props.cardId}>
        <Image src={member.fingerprinted_logo} responsive style={{ maxWidth: "350px" }} />
      </div>
    );

    let contactMember;
    if (this.props.currentUser) {
      const tooltip = <Tooltip id={`contact-tooltip${this.props.cardId}`}>To contact this utility use our messaging app</Tooltip>;
      contactMember = (
        <OverlayTrigger placement="top" overlay={tooltip}>
          <Button className="contact-member" onClick={this.contactButtonClick}>Go to messages</Button>
        </OverlayTrigger>
      );
    } else {
      contactMember = <Button className="contact-member" onClick={this.contactButtonClick}>Contact</Button>;
    }

    const foundationPartnerLink = <Button className="contact-member" href={hyperlinks["foundationPartner"]} >Foundation Partner Profile</Button>;

    let innovationAreas;
    if (member.innovation_areas) {
      innovationAreas = member.innovation_areas.map((area, i) => {
        const areaPresentationForMember = area.presentations.find(presentation => presentation.member_id == member.id);
        if (areaPresentationForMember) {
          return <PresentationModalContainer area={area} presentation={areaPresentationForMember} key={`innovationArea${i + 1}`} />;
        } else {
          return <div className="name" key={`innovationArea${i + 1}`}>{area.name}</div>;
        }
      });
    }

    let innovationAreasSection;
    if (member.organisation_type == "Utility") {
      innovationAreasSection = (
        <div>
          <div className="innovation-areas-heading">Innovation areas this utility is involved in</div>
          <div className="innovation-areas">{innovationAreas}</div>
        </div>
      );
    }

    let memberSinceDiv;
    if (member.organisation_type != "Sponsor") {
      memberSinceDiv = <div className="member-since">Member since {months[memberSince.getMonth()]} {memberSince.getFullYear()}</div>;
    }

    let overviewPresentation;
    if (member.overview_presentation) {
      overviewPresentation = <OverviewPresentationModalContainer area={`${member.name} Overview`} presentation={member.overview_presentation} />;
    }

    // const allEvents = this.props.events.map((e) => <div className="img-wrapper"><a href={e.hyperlink}><Image responsive src={e.fingerprinted_image} /></a></div>);

    const logos = [
      "/assets/SIWW-NEW-LOGO-Colour-93a6448cbf2ffa6bca00b3ad21fd41ea1b3d1130c715fd88127e6f0199739796.jpg",
      "/assets/aws-2017-3b3acf1e4c41ea1d122c17ba0c90411a66c6f2d25ec803cfe57fd9ffcee8246c.jpg",
      "/assets/GWS_2018_header-logo-58d8019fe68328147e3418d96a61be926c6516754a055a767117709036ae371f.png",
      "/assets/AIWW_logo_rgb-5e59c684609f0887e4bd24f1aec81a0a434d664fc7c98832163a70cf84c695b2.jpg",
    ];
    const luwo = <div className="img-wrapper"><a href="/"><Image responsive src="/assets/LUOW_2024_Vertical_Blue-3597b4329063f0d9e23bb1a88845acab12f8457a3301b5e03bb998631c5684d9.svg" /></a></div>;
    const allEvents = [luwo].concat(logos.map(logoPath => {
      const event = this.props.events.find(e => e.fingerprinted_image === logoPath);
      if (event) {
        return <div className="img-wrapper"><a href={event.hyperlink}><Image responsive src={logoPath} /></a></div>;
      } else {
        return <div className="img-wrapper"><Image responsive src={logoPath} /></div>;
      }
    }));

    const track = memberId => (e) => {
      e.preventDefault();
      axios.post("/analytics_messages.json", { type: 'go-to-website', member_id: memberId });
    }

    return (
      <Header showCorporateMembers={this.props.showCorporateMembers} flashes={this.props.flashes} currentUser={this.props.currentUser}>
        <Grid className="with-background event-sponsors-page">
          <Banner heading="Exclusive events partner" />
          <Row>
            <Col md={3}>
              <BackButton className="back-to-home" href={hyperlinks["events"]} text="❮ Events" />
            </Col>
            <Col md={3} mdOffset={6} className="text-right">
              <Button className="become-a-sponsor" href="mailto:a.smith@leadingutilities.org?Subject=Leading Utilities of the World - Become a corporate member&body=Dear Miss Abigail Smith,">{"Become a corporate member"}</Button>
            </Col>
          </Row>
          <Row className="event-sponsors-content">
            <Col md={12}>
              <Col md={12} className="expanded">
                <Row className="expanded-content">
                  {basicContent}

                  <Col md={4}>
                    {foundationPartnerLink}
                    {contactMember}
                    {overviewPresentation}
                    <Button className="go-to-website" onClick={track(member.id)} href={member.hyperlink} target="_blank">Go to website</Button>
                  </Col>
                  <Col md={8}>
                    <div className={member.organisation_type == "Utility" ? "close" : ""} onClick={this.props.handleClick}></div>
                    <span className="about-utility-heading">About {member.name}</span>
                    <div className="about-utility-content" dangerouslySetInnerHTML={{ __html: description }}></div>
                    {innovationAreasSection}
                  </Col>
                  <Col className="all-events-logos-sponsors" md={12}>
                    {allEvents}
                  </Col>
                </Row>
              </Col>
            </Col>
          </Row>
          <MemberContactModal showModal={this.state.showModal} closeModal={this.closeModal} />
        </Grid>
      </Header>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/components/EventSponsors.jsx.erb